import React, { createContext, ReactNode, useContext, useState } from "react";
import { IJiraAttachment, IJiraRenderedFields } from "../common/interface";

interface IAttachmentContext {
  attachments: IJiraAttachment[];
  setAttachments: React.Dispatch<React.SetStateAction<IJiraAttachment[]>>;
  renderedFields: IJiraRenderedFields | null;
  setRenderedFields: React.Dispatch<
    React.SetStateAction<IJiraRenderedFields | null>
  >;
  viewAttachmentIndex: number | null;
  setViewAttachmentIndex: React.Dispatch<React.SetStateAction<number | null>>;
}

const AttachmentContext = createContext<IAttachmentContext | undefined>(
  undefined
);

export const useAttachmentContext = (): IAttachmentContext => {
  const context = useContext(AttachmentContext);
  if (!context) {
    throw new Error(
      "useAttachmentContext must be used within an AttachmentProvider"
    );
  }
  return context;
};

interface AttachmentProviderProps {
  children: ReactNode;
}

export const AttachmentProvider: React.FC<AttachmentProviderProps> = ({
  children,
}) => {
  const [attachments, setAttachments] = useState<IJiraAttachment[]>([]);
  const [renderedFields, setRenderedFields] =
    useState<IJiraRenderedFields | null>(null);
  const [viewAttachmentIndex, setViewAttachmentIndex] = useState<number | null>(
    null
  );

  return (
    <AttachmentContext.Provider
      value={{
        attachments,
        setAttachments,
        renderedFields,
        setRenderedFields,
        viewAttachmentIndex,
        setViewAttachmentIndex,
      }}
    >
      {children}
    </AttachmentContext.Provider>
  );
};
